// Components==============
import React from 'react';
import { NavLink } from 'react-router-dom';
import './index.module.scss';
// =========================

export default function Logo() {
    return (
        <NavLink to="/" styleName="wrapper">
            <img
                src="/images/Logo Ontwikkelplatform NXT.svg"
                alt="Orion logo"
            />
        </NavLink>
    );
}
